/**
 * ExplosionManager
 * Handles the explosion of tiles and falling of these above of exploded ones.
 */

export default class ExplosionManager {

    // ==================== Construction ====================
    constructor(game, board, explosionsView) {
        this.game = game;
        this.board = board;
        this.explosionsView = explosionsView;
    }

    // ==================== Explosion ====================
    explodeTiles(tiles) {
        if (tiles.length < 1) return;
        // position in grid of lastly selected tile
        var lastCol = tiles[tiles.length - 1].col;
        var lastRow = tiles[tiles.length - 1].row;

        // used to determinate how much time will explosions take
        var maxTime = 0;
        var explosionOrder = [];

        for (var i = 0; i < tiles.length; i++) {
            var diffCol = Math.abs(lastCol - tiles[i].col);
            var diffRow = Math.abs(lastRow - tiles[i].row);

            // explosion delay for tile is based on its distance to the lastly selected tile
            var diff = (diffCol + diffRow) / 2 / PARAMS.scaleFactor;

            explosionOrder.push({tile: tiles[i], diff: diff});
        }
        explosionOrder = this.bubbleSortDiff(explosionOrder);

        var lastDiff = explosionOrder[0].diff;
        var counter = 0;
        for (var i = 0; i < explosionOrder.length; i++) {
            var diff = explosionOrder[i].diff;
            var tile = explosionOrder[i].tile;

            if (diff !== lastDiff) {
                lastDiff = diff;
                counter += 1
            }
            explosionOrder[i].counter = counter;

            var time = explosionOrder[i].counter * 125;
            if (time > maxTime) maxTime = time;
        }
        maxTime = Math.min(maxTime, 500);

        var timeStep = maxTime / explosionOrder.length;
        var counter = 0;
        for (var i = explosionOrder.length - 1; i >= 0; i--) {
            var diff = explosionOrder[i].diff;
            var tile = explosionOrder[i].tile;
            tile.explode();
            this.createExplosion(tile.view.x + (47 / 2 - 6) * PARAMS.scaleFactor, tile.view.y + (47 / 2 - 7) * PARAMS.scaleFactor, timeStep * i);
            counter += 1;
        }

        this.game.time.events.add(maxTime * 0.5, this.startFall, this)
    }

    createExplosion(x, y, delay) {
        var explo = PARAMS.makeSprite(this.game, 0, 0, 'flashAnims', 'tileMatchAnimation/0000');

        var frames = window.Phaser.Animation.generateFrameNames('tileMatchAnimation/', 0, 22, '', 4);

        explo.animations.add('explode', frames, 14, false);

        explo.anchor.set(0.5);

        explo.x = x;
        explo.y = y;
        this.explosionsView.add(explo);

        explo.events.onAnimationComplete.add(function () {
            this.explosionsView.removeChild(explo);
            explo.destroy();
            explo = null
        }, this);

        this.game.time.events.add(delay, function () {
            this.play('explode')
        }, explo);

        return explo
    }

    // ==================== Falling ====================
    startFall() {
        var maxTime = 0;

        for (var col = 0; col < this.board.columnsCount; col++) {
            var explodedUnderTile = 0;
            var tilesToRemove = [];

            for (var row = this.board.columnsCount - 1; row >= 0; row--) {
                // goes all rows from the bottom and looks for the ones just destroyed, to know
                // how much move down those above
                var tile = this.board.getTile(col, row);

                if (!tile.alive) {
                    explodedUnderTile += 1;
                    tilesToRemove.push(tile)
                } else if (explodedUnderTile > 0) {
                    var time = this.moveTileByY(tile, explodedUnderTile);

                    if (time > maxTime) maxTime = time
                }
            }

            // now fills the tiles on the top with empty ones
            for (var i = 0; i < tilesToRemove.length; i++) {
                tile = tilesToRemove[i];

                this.board.tilesViews.removeChild(tile);

                this.board.putEmpty(col, i)
            }
        }
        this.onShiftStart();
        this.game.time.events.add(maxTime, this.onFallEnd, this);
    }

    onFallEnd() {
        // this.onShiftStart()
    }

    // ==================== Shifting ====================
    onShiftStart() {
        var maxTime = 0;

        // counter holds empty cols from the middle to the left occuring before current col is met
        var counter = 0;

        for (var col = 4; col >= 0; col--) {
            if (this.isColumnEmpty(col)) {
                counter += 1;
            } else if (counter !== 0) {
                var time = this.moveColumnBy(col, counter);
                maxTime = Math.max(maxTime, time);
            }
        }

        // now fill all columns which are on the left with empty tiles
        while (counter > 0) {
            this.clearCol(counter - 1);
            counter--;
        }

        // here the situation is opposite
        // counter holds empty cols from the middle to the right occuring before current col is met
        counter = 0;

        for (col = 5; col < 10; col++) {
            if (this.isColumnEmpty(col)) {
                counter += 1
            } else if (counter !== 0) {
                // minus counter because here we move to the left!
                time = this.moveColumnBy(col, -counter);
                maxTime = Math.max(maxTime, time);
            }
        }

        // now fill all columns which are on the right with empty tiles
        while (counter > 0) {
            this.clearCol(10 - counter);
            counter--;
        }

        this.game.time.events.add(Math.max(maxTime, 350), this.onShiftEnd, this);
    }

    isColumnEmpty(col) {
        for (var row = 0; row < this.board.rowsCount; row++) {
            var tile = this.board.getTile(col, row);
            if (tile.alive) return false;
        }
        return true;
    }

    moveColumnBy(col, diffX) {
        var maxTime = 0;
        for (var row = 0; row < this.board.rowsCount; row++) {
            var time = this.moveTileByX(this.board.getTile(col, row), diffX);
            maxTime = Math.max(maxTime, time);
        }
        return maxTime;
    }

    onShiftEnd() {
        this.board.boardInputController.active = true;

        var buffLines = GS.lines;
        this.board.clearLineAnimator.checkRows();
        this.board.clearLineAnimator.checkColumns();

        if (buffLines !== GS.lines) AUDIO.playSound('emptyLine');
    }

    // ==================== Tile Movement ====================
    moveTileByY(tile, diffY) {
        tile.row += diffY;
        this.board.placeTile(tile);
        var targetY = tile.view.y + diffY * 47 * PARAMS.scaleFactor;
        var moveTime = 200 * diffY;
        this.game.add.tween(tile.view).to({y: targetY}, moveTime).start();
        return moveTime
    }

    moveTileByX(tile, diffX) {
        tile.col += diffX;
        this.board.placeTile(tile);
        var targetX = tile.view.x + diffX * 47 * PARAMS.scaleFactor;
        var moveTime = Math.abs(200 * diffX);
        this.game.add.tween(tile.view).to({x: targetX}, moveTime).start();
        return Math.abs(moveTime)
    }

    // ==================== Clearing ====================
    clearCol(col) {
        for (var row = 0; row < this.board.rowsCount; row++) {
            this.board.putEmpty(col, row)
        }
    }

    // ==================== Sorting ====================
    bubbleSortSwap(items, firstIndex, secondIndex) {
        var temp = items[firstIndex];
        items[firstIndex] = items[secondIndex];
        items[secondIndex] = temp;
    }

    bubbleSortDiff(a) {
        var swapped;
        do {
            swapped = false;
            for (var i = 0; i < a.length - 1; i++) {
                if (a[i].diff > a[i + 1].diff) {
                    var temp = a[i];
                    a[i] = a[i + 1];
                    a[i + 1] = temp;
                    swapped = true
                }
            }
        } while (swapped);
        return a;
    }
}
